var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLmntLogo = function SvgLmntLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71718E",
    d: "M20.0544 16.4117V9.71923L22.9302 14.084H22.9888L25.8925 9.67546V16.4136H28.1479V6.0944H25.7011L22.9888 10.4573L20.2758 6.09375H17.8283V16.4124H20.0544V16.4117ZM19.5955 21.6792H22.7363V29.9045H25.0066V21.6792H28.1465V19.5859H19.5955V21.6792ZM15.0691 14.3492H9.92304V6.09375H7.65332V16.4124H15.0691V14.3492Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#71718E",
    d: "M0.593262 0.692383V35.3078H35.2087V0.692383H0.593262ZM32.9389 33.0356H2.81677V2.96263H32.9389V33.0356Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#71718E",
    d: "M9.89375 23.3458L14.8927 29.905H16.8239V19.5864H14.5829V25.9413L9.74664 19.5864H7.65332V29.905H9.89375V23.3458Z"
  })));
};
export default SvgLmntLogo;